import { render, staticRenderFns } from "./realtimeInventory.vue?vue&type=template&id=3d6cb0d8&scoped=true&"
import script from "./realtimeInventory.vue?vue&type=script&lang=js&"
export * from "./realtimeInventory.vue?vue&type=script&lang=js&"
import style0 from "./realtimeInventory.vue?vue&type=style&index=0&id=3d6cb0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6cb0d8",
  null
  
)

export default component.exports